import { render, staticRenderFns } from "./taskDetail.vue?vue&type=template&id=78f1d78f&scoped=true"
import script from "./taskDetail.vue?vue&type=script&lang=js"
export * from "./taskDetail.vue?vue&type=script&lang=js"
import style0 from "../css/taskDetail.styl?vue&type=style&index=0&id=78f1d78f&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f1d78f",
  null
  
)

export default component.exports